export default function handleStatusDismissal(status) {
  const statusOptions = {
    START_OF_THE_PROCESS: 'Início do processo',
    FULFILLING_NOTICE: 'Cumprindo aviso',
    DISMISSED: 'Desligado',
  };

  return statusOptions[status];
}
